import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { DOCUMENT_TYPE_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_DELETE_CONFIG, DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG, DEFAULT_PUT_CONFIG } from '../../config/rest';
import {
  CLEAR_DOCUMENT_TYPE,
  CLEAR_DOCUMENT_TYPES,
  FLAG_GETTING_DOCUMENT_TYPE,
  FLAG_GETTING_DOCUMENT_TYPES,
  GET_DOCUMENT_TYPE,
  GET_DOCUMENT_TYPES,
} from '../types';
import { DOCUMENT_TYPE_PATH } from '../../config/paths';
import { push } from 'react-router-redux';

const flagGettingDocumentTypes = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_GETTING_DOCUMENT_TYPES,
  });

const getDocumentTypes = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingDocumentTypes(true));
    const query = tableFilters;
    const url = `${DOCUMENT_TYPE_ENDPOINT}?${QueryString.stringify(query)}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise);
    const response = await promise.json();
    dispatch({
      type: GET_DOCUMENT_TYPES,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingDocumentTypes(false));
  }
};

const clearDocumentTypes = () => (dispatch) =>
  dispatch({ type: CLEAR_DOCUMENT_TYPES });

const flagGettingDocumentType = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_GETTING_DOCUMENT_TYPE,
  });

const getDocumentType = async ({documentTypeId}) => async (dispatch) => {
  try {
    dispatch(flagGettingDocumentType(true));
    const url = `${DOCUMENT_TYPE_ENDPOINT}/${documentTypeId}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise);
    const response = await promise.json();
    dispatch({
      type: GET_DOCUMENT_TYPE,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingDocumentType(false));
  }
};

const createNewDocumentType = async ({
      name,
      description
}) => {
  const payload = {
    name,
      description
  };
  const url = DOCUMENT_TYPE_ENDPOINT;
  const promise = await fetch(url, {
    ...DEFAULT_POST_CONFIG,
    body: JSON.stringify(payload),
  });
  await isErrorResponse(promise);
  const endpoint = await promise.json();
  return endpoint;
};

  const postDocumentType =
    async ({
      name,
      description
    }) =>
    async (dispatch) => {
      try {
        dispatch(flagGettingDocumentType(true));
        const response = await createNewDocumentType({
       name,
      description
        });
        if (response) {
          dispatch(push(`${DOCUMENT_TYPE_PATH}/${response.id}`));
        }
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagGettingDocumentType(false));
      }
    };

    const putDocumentType =
  async (
    documentTypeId,
    {
      name,
      description
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingDocumentType(true));
      const payload = {
        id: documentTypeId,
        name,
      description
      };
      const url = `${DOCUMENT_TYPE_ENDPOINT}/${documentTypeId}`;
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(`${DOCUMENT_TYPE_PATH}/${documentTypeId}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingDocumentType(false));
    }
  };

  const deleteDocumentType =
  async ({ documentTypeId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingDocumentType(true));
      const url = `${DOCUMENT_TYPE_ENDPOINT}/${documentTypeId}`;
      const promise = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(DOCUMENT_TYPE_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingDocumentType(false));
    }
  };

const clearDocumentType = () => (dispatch) =>
  dispatch({ type: CLEAR_DOCUMENT_TYPE });

export { clearDocumentTypes, getDocumentTypes, getDocumentType, postDocumentType, putDocumentType, deleteDocumentType, clearDocumentType };
